import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const NotFound: React.FC = () => {
  return (
    <div style={{ paddingTop: '140px', paddingBottom: '140px', textAlign: 'center' }}>
      <div className="container-max" style={{ maxWidth: '600px' }}>
        <div
          className="font-mono"
          style={{
            fontSize: '5rem',
            fontWeight: 800,
            color: 'var(--brand-red)',
            marginBottom: '10px',
            textShadow: '0 0 30px rgba(229, 57, 53, 0.4)',
          }}
        >
          404
        </div>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '16px' }}>
          Page Not Found
        </h1>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
          The ultimate answer may be 42, but this page does not exist. Let's return to the financial intelligence platform.
        </p>
        <Link to="/" className="btn-primary" style={{ display: 'inline-flex', padding: '12px 24px' }}>
          <ArrowLeft size={16} />
          <span>Return Home</span>
        </Link>
      </div>
    </div>
  );
};
